import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FiWrapperTableAdditionalColumns } from '@fi-shared/fi-wrapper-table/fi-wrapper-table-additional-columns';
import { IChecklistV2ForList } from '@fi-shared/checklist/checklist-v2';
import { FiChecklistHelperService } from '@fi-shared/checklist/fi-checklist-helper.service';

@Component({
    selector: 'fi-checklist2-list-checkpoints-status',
    templateUrl: './fi-checklist2-list-checkpoints-status.component.html',
    styleUrls: ['./fi-checklist2-list-checkpoints-status.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-checklist2-list-checkpoints-status' },
    providers: [{ provide: FiWrapperTableAdditionalColumns, useExisting: FiChecklist2ListCheckpointsStatusComponent }],
    standalone: false,
})
export class FiChecklist2ListCheckpointsStatusComponent extends FiWrapperTableAdditionalColumns {
    constructor(private fiChecklistHelperService: FiChecklistHelperService) {
        super();
    }

    getFilledCheckpointsCount(item: IChecklistV2ForList): number {
        if (this.fiChecklistHelperService.isAuditOnDemandNotActive(item.IsActive, item.ScheduleType)) {
            return 0;
        }

        return item.FilledCheckpointsCount;
    }
}
